// service/dataBackupPlanService.js
import { postAction, safeParseJson } from "./apiHelpers";

const URL = "https://pro.mokshiq.in/data_backup_plan_manager";

// These fields are sent as JSON strings (see curl: backup_attributes, created_by)
const JSON_FIELDS = ["backup_attributes", "created_by"];

/**
 * Matches these curl actions:
 *   action=GET
 *   action=GETBYID&id=...
 *   action=ADDUPDATE&id=...(optional)&website_plan=...&monthly_business_limit=...
 *            &backup_attributes={...json...}&status=...&created_by={...json...}
 *   action=DELETE&id=...
 *
 * backup_attributes shape (from curl example):
 * {
 *   "30_days":  { "enabled": true, "price": 100 },
 *   "60_days":  { "enabled": true, "price": 200 },
 *   "90_days":  { "enabled": true, "price": 300 },
 *   "180_days": { "enabled": false, "price": 500 },
 *   "365_days": { "enabled": true, "price": 800 },
 *   "720_days": { "enabled": false, "price": 1200 },
 *   "ad1": 100,
 *   "ad2": 200
 * }
 */
export const dataBackupPlanService = {
  getAll: () => postAction(URL, { action: "GET" }),

  getById: (id) => postAction(URL, { action: "GETBYID", id }),

  addOrUpdate: ({
    id,
    website_plan,
    monthly_business_limit,
    backup_attributes,
    status = "true",
    created_by,
  }) =>
    postAction(
      URL,
      {
        action: "ADDUPDATE",
        ...(id ? { id } : {}),
        website_plan,
        monthly_business_limit,
        backup_attributes,
        status,
        created_by,
      },
      JSON_FIELDS
    ),

  remove: (id) => postAction(URL, { action: "DELETE", id }),

  // Helper for consumers reading GET/GETBYID results — normalizes JSON columns
  // that may come back as strings from the backend.
  normalize: (record) => ({
    ...record,  
    backup_attributes: safeParseJson(record.backup_attributes, {}),
    created_by: safeParseJson(record.created_by, {}),
  }),
};

export default dataBackupPlanService;